import { render, staticRenderFns } from "./PlaygroundDocumentsV2.vue?vue&type=template&id=7d5f8524"
import script from "./PlaygroundDocumentsV2.js?vue&type=script&lang=js&external"
export * from "./PlaygroundDocumentsV2.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports